<template>
    <div>
        <div class="cb_thanks" v-if="type=='purchase'">
            <div>{{ characters.end_purchase }}</div>
            <div>{{ characters.thank_to_purchase }}</div>
        </div>
        <div class="cb_thanks" v-if="type=='regist'">
            <div>{{ characters.thank_to_regist }}</div>
        </div>
        <div v-if="pay_kind === 'credit' && type!='regist'" class="cb_thanks">
            <form :id="pay_kind" target="_top">
                <input type="hidden" name="_token" :value="csrf_token">
            </form>
            <div id="jump-store" class="confirm"><button type="submit" @click="regist">{{ characters.regist_card_info }}</button></div>
        </div>
        <div class="cb_thanks">
            <div id="jump-store" class="confirm"><button type="submit" @click="jumpStore">{{ characters.back_to_store }}</button></div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "purchase-end",
        props: ['csrf_token', 'pay_kind', 'order_site', 'type', 'json_characters'],
        data: function () {
            return {
                characters: Object,
            }
        },
        mounted() {
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            jumpStore: function() {
                location.href = "/store";
            },
            regist: function() {
                let form = document.forms[this.pay_kind];
                form.action = this.order_site+'/regist_'+this.pay_kind+'.php';
                form.method = 'POST';
                // console.log(form);
                axios.default
                    .post('/purchase/regist', {pay_kind: this.pay_kind})
                    .then(response => {
                        for(const key in response.data) {
                            form.innerHTML+='<input type="hidden" name="'+key+'" value="'+response.data[key]+'">';
                            // console.log(data);
                        }
                        // console.log(form);
                        form.submit();
                    });
            },
        }
    }
</script>

<style scoped>
</style>
